module.exports = __webpack_public_path__ + "img/img-1.7be4b8cd.png";